
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work/[[...category]]",
      function () {
        return require("private-next-pages/work/[[...category]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/work/[[...category]]"])
      });
    }
  